import request from '../utils/csrf-superagent';
import config from '../config';
import businessModelActions from '../actions/businessModel';
import appActions from '../actions/actions';
import {APP_STATE, MERCHANT_OF_RECORD, USER_TYPE} from '../utils/constants';

function submitBusinessModel(store, action) {
    const { businessModelChoice } = action.payload;

    const state = store.getState();
    const userInfoMetadata = state.userInfoDetails?.userInfoMetadata || {};
    const softwareDetails = state.softwareDetails || {};

    if (!userInfoMetadata.ipm && !softwareDetails.systemId && !softwareDetails.softwareId && !softwareDetails.onboardAdvertiserDetails) {
        store.dispatch(appActions.enableLoadOverLay(false));
        store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
        return;
    }

    const systemId = softwareDetails.systemId ||
                    softwareDetails.onboardAdvertiserDetails?.systemId ||
                    userInfoMetadata.ipm?.externalSystemId;

    const advertiserId = softwareDetails.softwareId ||
                        softwareDetails.onboardAdvertiserDetails?.externalId ||
                        userInfoMetadata.ipm?.externalId;

    if (!systemId || !advertiserId) {
        store.dispatch(appActions.enableLoadOverLay(false));
        store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
        return;
    }

    const payload = {
        businessModel: businessModelChoice,
        systemId,
        advertiserId
    };

    request.post(`/${config.url_prefix}/api/advertiser/businessModel`)
        .send(payload)
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(appActions.enableLoadOverLay(false));
                store.dispatch(businessModelActions.alertError('ipmob.internal.server.error'));
            } else if (response.statusCode === 200 || response.statusCode === 201) {
                store.dispatch(businessModelActions.submitBusinessModelSuccess());
                if (userInfoMetadata.pmType === USER_TYPE.IPM_SOFTWARE_SWITCH) {
                    const appState = businessModelChoice === MERCHANT_OF_RECORD.EG ? APP_STATE.PAYOUT_DETAILS : APP_STATE.LISTING_MODEL;
                    store.dispatch(appActions.changeAppState(appState));
                } else {
                    store.dispatch(appActions.changeAppState(APP_STATE.MAILING_INFORMATION));
                }
            } else {
                store.dispatch(appActions.enableLoadOverLay(false));
                store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default submitBusinessModel;
